import request from "../util/request";
import SERVER_URL from "../util/seaver";

function clockin(reqData) {
  const reqUrl =
    SERVER_URL + "/clockin/clockin";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}

function clockinSel(reqData) {
  const reqUrl =
    SERVER_URL + "/clockin/sel";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}

function clockinSta(reqData) {
  const reqUrl =
    SERVER_URL + "/clockin/sta";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
export { clockin, clockinSel, clockinSta };
